import { ApiHandler, createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { BrandsSmeModel, getBrandListById } from "@tCentro/Services/CENAdminBrandListService";
import { EmployeeCollectionModel, EmployeeModel, getEmployeeById, getEmployeeCollection } from "@tCentro/Services/CENAdminEmployeeService";
import { ProductTypeModel } from "@tCentro/Services/CENAdminProductTypeService";
 
export interface GetBrandListIdParameter extends HasOnSuccess<BrandsSmeModel>, HasOnError<string> {
    id: string;
}
 
type HandlerType = ApiHandler<GetBrandListIdParameter, { apiResult: BrandsSmeModel }>;
 
export const GetBrandListById: HandlerType = async props => {
    try {
           const result = await getBrandListById(props.parameter.id);
           if (props.parameter.onSuccess) {
               props.parameter.onSuccess(result);
           }
       } catch (error: any) {
           if (props.parameter.onError) {
               props.parameter.onError(error?.message ?? "Failed to load employees");
           }
       }
};
 
export const chain = [GetBrandListById];
const getBrandListsById = createHandlerChainRunner(chain, "getBrandListsById");
export default getBrandListsById;
